import SectionJobCategories from "../../sections/Clients/section-job-categories";
import SectionHowItWorks from "../../sections/Clients/section-how-it-works";
import SectionUploadCV from "../../sections/Clients/section-upload-cv";
import SectionTopCompanies from "../../sections/Clients/section-top-companies";
import { useEffect } from "react";
import { loadScript } from "../../../../../globals/constants";

function ClientsPage() {

  useEffect(() => {
    loadScript("js/custom.js");
  })

  return (
    <>


<section className="hero rounded-3 mb-5 p-5">
  <div className="container">
    <div className="row justify-content-center align-items-center">
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/1.jpg" alt="client1" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/2.jpg" alt="client2" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/3.jpg" alt="client3" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/4.jpg" alt="client4" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/5.jpg" alt="client5" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/6.jpg" alt="client6" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/7.jpg" alt="client7" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/8.jpg" alt="client8" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/9.jpg" alt="client9" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/10.jpg" alt="client10" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/11.jpg" alt="client11" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/12.jpg" alt="client12" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/13.jpg" alt="client13" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/14.jpg" alt="client14" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/15.jpg" alt="client15" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/16.jpg" alt="client16" className="img-fluid w-100" />
        </div>
      </div>
      <div className="col-lg-2 col-md-3 col-4 mb-3">
        <div className="client-pic">
          <img src="assets/images/clients/17.jpg" alt="client17" className="img-fluid w-100" />
        </div>
      </div>
    </div>
  </div>
</section>


    </>
  )
}

export default ClientsPage;